<template>
  <div class="container">
    <div class="title-block">
      {{ $t('COOKIE POLICY') }}
    </div>
    <div class="flex justify-between" style="scroll-behavior: smooth">
      <div class="main-info">
        <div class="paragraph-block">
          <ol class="main-ol">
            <li ref="general" class="paragraph-title">
              {{ $t('GENERAL') }}
              <ol class="paragraph-element">
                <li>
                  {{
                    $t(
                      'In order to optimally provide our service on the website https://dreamflat.design (referred to as “Website”), we use cookies and other technologies for the data processing. We use this information to make decisions about ways to improve our services and to make your browsing experience easier and more efficient.',
                    )
                  }}
                </li>
                <li v-if="!isDflat">
                  {{
                    $t(
                      'This Cookie policy is issued by DreamFlat FZ-LLC registered in the Register of Companies of Dubai, with number 45001026 (referred to as “DreamFlat” or “we”) to provide detailed information about how and when we use cookies. The use of cookies may sometimes be related to personal data processing, therefore we recommend you consult our Privacy Policy.',
                    )
                  }}
                </li>
                <li v-if="isDflat">
                  {{
                    $t(
                      'This Cookie policy is issued by VR INVEST LLC, with number 45001026 (referred to as “DreamFlat” or “we”) to provide detailed information about how and when we use cookies. The use of cookies may sometimes be related to personal data processing, therefore we recommend you consult our Privacy Policy.',
                    )
                  }}
                </li>
              </ol>
            </li>
            <li ref="cookie-notice" class="paragraph-title">
              {{ $t('COOKIE NOTICE') }}
              <ol class="paragraph-element">
                <li>
                  Cookies are small text files which includes a unique
                  identifier that are sent by a web server to user’s
                  device as a user access to a website and are widely
                  used to make sites work efficiently. They are
                  processed and stored by your web browser. Your
                  browser sends previously stored cookies to the
                  website, which may contain, among other things, your
                  IP address, and information about the operating
                  system and browser.
                </li>
              </ol>
            </li>
            <li ref="types-cookie" class="paragraph-title">
              {{ $t('TYPES COOKIES WE USE') }}
              <ol class="paragraph-element">
                <li>
                  We use all or some of the following categories of
                  cookies on the Website:
                  <ol>
                    <li>
                      <b>Strictly necessary cookies</b><br />
                      These cookies are essential for you to browse
                      the Website and use its features, such as
                      accessing secure areas of the Website.
                    </li>
                    <li>
                      <b
                        >Preferences cookies (or “functionality
                        cookies”)</b
                      ><br />
                      These cookies save choices which you have made
                      on the Website in the past, e.g. your language
                      and the country you visit the Website from, or
                      what your user name and password are so you can
                      automatically log in.
                    </li>
                    <li>
                      <b
                        >Statistics cookies (or “performance
                        cookies”)</b
                      ><br />
                      These cookies store information about how you
                      use the Website in order to help us to improve
                      the functionality of the Website and fix
                      technical issues or errors. This includes pages
                      you visited and which links you clicked on. The
                      information stored by these cookies never shows
                      personal details from which your identity can be
                      established. It is all aggregated and,
                      therefore, anonymized.
                    </li>
                    <li>
                      <b
                        >Marketing cookies (or “advertising
                        cookies”)</b
                      ><br />
                      These cookies help us to inform you and provide
                      you with customized advertisements based on your
                      past use of the website or/and Services. These
                      cookies are monitoring your usage data and by
                      using cookies, information, which information is
                      not considered as personal data, is transferred
                      to the partners that manage the remarketing and
                      behavioral targeting activity.
                    </li>
                  </ol>
                </li>
                <li>
                  In order to facilitate access to our Website and for
                  statistical analysis, we store several cookies
                  permanently on your device. But no personal data is
                  used or generated in these cookies.
                </li>
              </ol>
            </li>
            <li ref="consent" class="paragraph-title">
              {{ $t('CONSENT TO THE USE OF COOKIES') }}
              <ol class="paragraph-element">
                <li>
                  The processing of your data takes place partly on
                  the basis of legitimate interest, in part we need
                  your consent for it. Your consent is not required
                  for the use by the website of Strictly necessary
                  cookies, as they are essential for the Website to
                  function. Other cookies will not be used until you
                  consent to their use. Your selection will only be
                  applied to this service.
                </li>
              </ol>
            </li>
            <li ref="adjustment" class="paragraph-title">
              {{ $t('ADJUSTMENT OF COOKIE SETTINGS') }}
              <ol class="paragraph-element">
                <li>
                  At any time, you have an option of setting your
                  browser so that either cookies are not set or that
                  you are notified when cookies are received. For
                  instructions on how to block, delete or disable any
                  cookies, please consult your browser&#39;s
                  &#39;Help&#39; or &#39;Support&#39; section. Please
                  note that by deleting our cookies or disabling
                  future cookies you may not be able to access certain
                  areas or features of the Website. In order to be
                  able to use the full functionality of the Website,
                  you should allow the storage of cookies on your
                  system.
                </li>
              </ol>
            </li>
          </ol>
        </div>
      </div>
      <div class="legal-table-contents">
        <ol>
          <li>
            <a @click="scrollToAnchorPoint('general')">{{
              $t('GENERAL')
            }}</a>
          </li>
          <li>
            <a @click="scrollToAnchorPoint('cookie-notice')">{{
              $t('COOKIE NOTICE')
            }}</a>
          </li>
          <li>
            <a @click="scrollToAnchorPoint('types-cookie')">{{
              $t('TYPES COOKIES WE USE')
            }}</a>
          </li>
          <li>
            <a @click="scrollToAnchorPoint('consent')">{{
              $t('CONSENT TO THE USE OF COOKIES')
            }}</a>
          </li>
          <li>
            <a @click="scrollToAnchorPoint('adjustment')">{{
              $t('ADJUSTMENT OF COOKIE SETTINGS')
            }}</a>
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import {useI18n} from 'vue-i18n';
import {useHead, useRuntimeConfig} from '#imports';

export default {
  setup() {
    const {t} = useI18n();
    const runtimeConfig = useRuntimeConfig();
    const isDflat =
      runtimeConfig.public.vueAppBaseUrl.includes('d-flat.ru');
    useHead({
      title: `${t(runtimeConfig.public.vueAppTitle)} - ${t(
        'cookiePolicy',
      )}`,
      meta: [
        {
          name: 'description',
          content: `${t('cookiePolicyMetaDesc')}`,
        },
      ],
    });
    useSeoMeta({
      ogTitle: `${t('DreamFlat')} - ${t('cookiePolicy')}`,
      description: `${t('cookiePolicyMetaDesc')}`,
      ogDescription: `${t('cookiePolicyMetaDesc')}`,
      ogImage: 'https://dreamflat.design/prev.webp',
    });
    return {
      isDflat,
    };
  },
  data() {
    return {
      items: [
        'general',
        'cookie-notice',
        'types-cookie',
        'consent',
        'adjustment',
      ],
      activeIndex: 0,
    };
  },
  methods: {
    scrollToAnchorPoint(refName: string) {
      (this as any).currentActiveSection = refName;
      const el = (this as any).$refs[refName];
      el.scrollIntoView({behavior: 'smooth'});
    },
  },
};
</script>
<style lang="scss" scoped>
.title-block {
  font-size: 36px;
  font-weight: 700;
  margin: 30px 0 60px 0;
  color: #3d424a;
  line-height: 120%;
  letter-spacing: 0.03em;
}
.main-info {
  width: 650px;
  .paragraph-block {
    color: #3d424a;
    ol {
      margin: 0 0 1.5em;
      padding: 0;
    }
    .main-ol {
      counter-reset: item;
    }
    ol > li {
      padding: 0 0 0 1.5em;
      text-indent: -1.5em;
      list-style-type: none;
    }
    ol > li:before {
      display: inline-block;
      width: 1.5em;
      padding-right: 0.5em;
      font-weight: bold;
      text-align: right;
    }
    .main-ol > li {
      counter-increment: item;
    }
    .main-ol > li:before {
      content: counter(item) '.';
    }
    .main-ol > li ol > li {
      counter-increment: item-t;
    }
    .main-ol > li ol > li:before {
      content: counter(item) '.' counter(item-t);
    }

    .main-ol > li ol > li ol > li {
      counter-increment: item-three;
      padding: 0 0 0 3.1em;
      text-indent: -1.5em;
      margin: 16px 0;
    }

    .main-ol > li ol > li ol > li:before {
      display: inline-block;
      width: 1.5em;
      padding-right: 0.5em;
      font-weight: bold;
      text-align: right;
      content: counter(item) '.' counter(item-t) '.'
        counter(item-three);
    }

    a {
      color: $primary;
      text-decoration: none;
    }
    .paragraph-title {
      font-size: 24px;
      font-weight: 700;
      .paragraph-element > * {
        font-size: 16px;
        font-weight: 400;
        line-height: 140%;
        letter-spacing: 0.03em;
        margin: 16px 0;
      }
    }
  }
}
.legal-table-contents {
  width: 265px;
  ol {
    color: #839aaf;
    padding: 0;
    margin: 0 0 1.1em;
    position: sticky;
    top: 50px;
    li {
      list-style-position: inside;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.02em;
      margin-bottom: 8px;
      padding: 0 0 0 1.1em;
      text-indent: -1.1em;
      cursor: pointer;
    }
    a {
      text-decoration: none;
      color: #839aaf;
    }
    a:active {
      color: #64686e;
    }
  }
}
@media (max-width: 1024px) {
  .main-info {
    width: 100%;
  }
  .legal-table-contents {
    width: 100%;
  }
  .title-block {
    margin-top: 32px;
  }
}
@media (max-width: 700px) {
  .title-block {
    font-size: 24px;
    line-height: 32px;
    margin: 32px 0 24px 0;
  }
  .legal-info-box {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    .main-info {
      width: 100%;
      .paragraph-block {
        .main-ol {
          .paragraph-title {
            font-size: 18px;
          }
          .paragraph-element {
            li {
              font-size: 15px;
              line-height: 140%;
            }
          }
        }
      }
    }
  }
  .legal-table-contents {
    display: none;
  }
}
</style>
